import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {ReviewStatusVO} from "@/service/instance.s";
import {FieldworkPO} from "@/model/customer";
import {WriteFieldworkForm} from "@/pages/Fieldwork/WriteFieldwork";

export enum FieldworkEnum {
    GetFieldworkPage = "/fieldwork/getFieldworkPage",
    GetFieldwork = "/fieldwork/getFieldwork",
    UpdateFieldwork = "/fieldwork/updateFieldwork",
    CreateFieldwork = "/fieldwork/createFieldwork",
}

export interface FieldworkPageBO {
    keyword?: string;
}

export interface FieldworkPageVO extends ReviewStatusVO, FieldworkPO {
}

export interface FieldworkVO extends FieldworkPO {
    mobile: string;
    contact: string
}

export const useQueryFieldworkPage = () => useMutation({
    mutationFn: (data: FieldworkPageBO) => http.post<BaseVO<PaginationVO<FieldworkPageVO>>>({
        url: FieldworkEnum.GetFieldworkPage,
        data: data,
    }),
})

export const useCreateFieldwork = () => useMutation({
    mutationFn: (data: WriteFieldworkForm) => http.put({url: FieldworkEnum.CreateFieldwork, data}),
})

export const useUpdateFieldwork = () => useMutation({
    mutationFn: (data: WriteFieldworkForm) => http.post({url: FieldworkEnum.UpdateFieldwork, data}),
})

export const useQueryFieldwork = (params: GetByIdBO, enabled = true) => useQuery({
    queryKey: [params.id],
    queryFn: () => http.get<BaseVO<FieldworkVO>>({url: FieldworkEnum.GetFieldwork, params}),
    enabled
});




